import {TransactionDirection} from '@sollapay/enums';

import {PayinTransactionRow} from './PayinTransactionRow';
import {PayoutTransactionRow} from './PayoutTransactionRow';

import type {TrustAccountTransactionDTO} from '@sollapay/types';
import type {FC} from 'react';

interface TransactionRowProps {
  transaction: TrustAccountTransactionDTO;
}

export const TransactionRow: FC<TransactionRowProps> = ({transaction}) =>
  transaction.direction === TransactionDirection.CREDIT ? (
    <PayinTransactionRow transaction={transaction} />
  ) : (
    <PayoutTransactionRow transaction={transaction} />
  );
